
export default function Services() {
  const services = [
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Financiación para innovar',
      description: 'Conectamos a PYMES, ayuntamientos y entidades locales con programas de financiación pública y privada. Analizamos convocatorias, redactamos proyectos y acompañamos durante todo el proceso de solicitud y ejecución.'
    },
    {
      icon: 'ri-smartphone-line',
      title: 'Impulso a la digitalización',
      description: 'Ayudamos a incorporar tecnología, herramientas digitales y procesos innovadores adaptados a la realidad rural. Desde plataformas colaborativas hasta estrategias de marketing digital o eficiencia energética.'
    },
    {
      icon: 'ri-team-line',
      title: 'Conocimiento y colaboración',
      description: 'Creamos espacios formativos y redes de cooperación donde compartir experiencias, recursos e ideas. Porque la innovación crece cuando se comparte.'
    }
  ];

  return (
    <section id="que-hacemos" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Transformamos ideas en proyectos que cambian territorios
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trabajamos para que la innovación deje de ser una palabra y se convierta en acción.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-8 hover:shadow-lg transition-shadow">
              <div className="w-16 h-16 bg-teal-600 rounded-lg flex items-center justify-center mb-6">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {index + 1}. {service.title}
              </h3>
              
              <p className="text-gray-700 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-teal-50 rounded-xl p-8 max-w-4xl mx-auto">
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20rural%20innovation%20workspace%20with%20digital%20technology%2C%20laptops%20and%20tablets%20on%20wooden%20desk%2C%20sustainable%20office%20environment%20with%20natural%20lighting%2C%20green%20plants%2C%20representing%20digital%20transformation%20in%20rural%20areas%2C%20clean%20and%20professional%20atmosphere%2C%20bright%20colors&width=800&height=400&seq=services-territorio360&orientation=landscape"
              alt="Servicios de innovación territorial"
              className="w-full h-64 object-cover rounded-lg mb-6"
            />
            <p className="text-lg text-gray-700 italic">
              "Cada proyecto es una oportunidad para demostrar que la innovación no tiene fronteras geográficas."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
